import React from 'react';
import {connect} from 'react-redux';
import uuid from "uuid";

// import template from '../../templates/Discounts/DiscountsHeader.rt'; // not used, deleted
import {
  setDiscountSections,
  // toggleEnableWorksheet,
  // toggleEnableWorksheetForClients
} from "./discountsActions";
import {
  defaultDiscount,
  defaultDiscountSection,
  DISCOUNT_MAIN_TYPES,
  DISCOUNT_SECTION_TYPES
} from "./discountsInterface";
import {getNextMaxNumberFromList} from "../../utilities";
import {
  getCurrentWorkSheetSections,
  getDiscountSectionDefaultWizardLogic, getLowesIMEActive,
  getParsedWizardLogic, getUpdatedDiscountSectionsWithWizardLogic
} from "./discountsFunctions";
import CheckBox from "../PageLayout/CheckBox";
import Select5 from "../Generic/Select5";

const getNewDiscountName = (discountType, discounts) => {
  switch (discountType) {
    case DISCOUNT_MAIN_TYPES.subTotal:
      return "Sub total " + discounts.length
    case DISCOUNT_MAIN_TYPES.freeFill:
      return ""
    case DISCOUNT_MAIN_TYPES.deposit:
      return "Deposit"
    default:
      return defaultDiscount.name + " " + discounts.length
  }
}

const getDiscountLabel = (discountType) => {
  switch (discountType) {
    case DISCOUNT_MAIN_TYPES.custom:
      return "+ Add Custom Item"
    case DISCOUNT_MAIN_TYPES.freeFill:
      return "+ Add Free Fill Item"
    case DISCOUNT_MAIN_TYPES.subTotal:
      return "+ Add Sub Total Item"
    case DISCOUNT_MAIN_TYPES.nested:
      return "+ Add Nested Module"
    case DISCOUNT_MAIN_TYPES.finance:
      return "+ Add Financing"
    case DISCOUNT_MAIN_TYPES.deposit:
      return "+ Add Deposit"
    case DISCOUNT_MAIN_TYPES.lowesIME:
      return "+ Add Lowes IME Item"
    default:
      return "+ Add New Item"
  }
}


class DiscountsHeader extends React.Component {

  // toggleEnableWorkSheet = (checked) => {
  //   this.props.toggleEnableWorksheet(checked)
  // };

  // toggleEnableWorksheetForClients = (checked) => {
  //   this.props.toggleEnableWorksheetForClients(checked)
  // };

  toggleEnableLowesIME = () => {
    const {discountSections, currentSheetSections, workSheetsActiveIndex} = this.props;
    const parsedLogic = getParsedWizardLogic(currentSheetSections[0], workSheetsActiveIndex);
    const newWizardLogic = {
      ...parsedLogic,
      forLowesIME: !getLowesIMEActive(currentSheetSections)
    };
    const updatedSections = getUpdatedDiscountSectionsWithWizardLogic(
      discountSections,
      newWizardLogic,
      workSheetsActiveIndex
    );
    this.props.setDiscountSections(updatedSections);
  };

  isDisabledDiscountAdd = (discountType) => {
    if (discountType === DISCOUNT_MAIN_TYPES.finance) {
      return this.props.currentSheetSections.some(section => {
        return section.type !== DISCOUNT_SECTION_TYPES.finance && section.discounts.some(dis => {
          return dis.discountType === DISCOUNT_MAIN_TYPES.finance
        })
      })
    }
    if (discountType === DISCOUNT_MAIN_TYPES.deposit) {
      return this.props.currentSheetSections.some(section => {
        return section.discounts.some(dis => dis.discountType === DISCOUNT_MAIN_TYPES.deposit)
      })
    }
    return false
  }

  handleAddItemClick = (selectedItem) => {
    const discountType = selectedItem.value;
    if (this.isDisabledDiscountAdd(discountType)) {
      return;
    }

    let {discountSections, currentSheetSections} = this.props;

    if (!currentSheetSections.filter(sec => sec.type !== DISCOUNT_SECTION_TYPES.finance).length) {
      discountSections.push(this.getDefaultSection());
    }
    if (discountType === DISCOUNT_MAIN_TYPES.finance) {
      if (!currentSheetSections.some(section => section.type === DISCOUNT_SECTION_TYPES.finance)) {
        this.handleAddSectionClick(DISCOUNT_SECTION_TYPES.finance)
      }
    }
    if (this.isDisabledDiscountAdd(discountType)) {
      return // for not we can have only one
    }
    const normalSections = getCurrentWorkSheetSections(
      discountSections.filter(sec => sec.type !== DISCOUNT_SECTION_TYPES.finance),
      this.props.workSheetsActiveIndex,
    );
    const discounts = normalSections[normalSections.length - 1].discounts;
    const uuidId = uuid.v4();
    discounts.push(Object.assign({}, defaultDiscount, {
      id: uuidId,
      uuId: uuidId,
      discountType,
      name: getNewDiscountName(discountType, discounts),
      order: getNextMaxNumberFromList(discounts, "order"),
      isRidged: discountType === DISCOUNT_MAIN_TYPES.freeFill,
      isSubTotal: discountType === DISCOUNT_MAIN_TYPES.subTotal
    }));
    this.props.setDiscountSections(discountSections);
    this.scrollToTheBottom(uuidId);
  };

  handleAddSectionClick = (type = DISCOUNT_SECTION_TYPES.default) => {
    const discountSections = this.props.discountSections;
    discountSections.push(this.getDefaultSection(type));
    this.props.setDiscountSections(discountSections);
    this.scrollToTheBottom();
  };

  getDefaultSection = (type) => {
    const {discountSections, workSheetsActiveIndex, isLowesIMEActive} = this.props;
    let displayOptions = [];
    discountSections.forEach(section => {
      const wizLogic = getParsedWizardLogic(section, workSheetsActiveIndex);
      if (wizLogic.index === workSheetsActiveIndex && wizLogic.displayOptions.length) {
        displayOptions = wizLogic.displayOptions; // same displayOptions!
      }
    });
    return Object.assign({}, {
      id: uuid.v4(),
      type,
      wizardLogic: getDiscountSectionDefaultWizardLogic(workSheetsActiveIndex, displayOptions, isLowesIMEActive),
      order: getNextMaxNumberFromList(discountSections, "order"),
      name: defaultDiscountSection.name + " " + (discountSections.length + 1),
      discounts: []
    })
  };

  scrollToTheBottom = (uuId) => {
    setTimeout(() => {
      const element = document.querySelector(`[data-id='${uuId}']`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
    }, 0)
  };

  renderDropdownItems = () => {
    return Object.values(DISCOUNT_MAIN_TYPES).map(discountType => {
      // if (discountType === DISCOUNT_MAIN_TYPES.finance) {
      //   return null
      // }
      const label = getDiscountLabel(discountType);
      const disabled = this.isDisabledDiscountAdd(discountType);
      return {
        value: discountType,
        label,
        html: (
          <span className={"select3-dropdown__list-item-text width-95 line--16 text-capitalize"
            + (disabled ? " disabled inactive" : "")}>
            {label}
          </span>
        )
      }
    })
  }

  render() {
    return (
      <div className="discounts-header">
        <div className="discounts-header__settings flex flex--center flex--between">
          <div className="flex-item">
            {/*<div class="discounts-header__settings-checkbox">*/}
            {/*  <CheckBox checked="{this.props.enableWorksheet}"*/}
            {/*            onChecked="{(checked) => this.toggleEnableWorkSheet(!checked)}"*/}
            {/*            text="Enable Worksheet"/>*/}
            {/*</div>*/}
            {/*<div class="discounts-header__settings-checkbox">*/}
            {/*  <CheckBox checked="{this.props.enableWorksheetForClients}"*/}
            {/*            onChecked="{(checked) => this.toggleEnableWorksheetForClients(!checked)}"*/}
            {/*            text="Enable Worksheet For Client"/>*/}
            {/*</div>*/}
            <div className="discounts-header__settings-checkbox">
              <CheckBox checked={getLowesIMEActive(this.props.currentSheetSections)}
                        disabled={!this.props.currentSheetSections.length}
                        onChecked={this.toggleEnableLowesIME}
                        text="For Lowes Work Order ID"/>
            </div>
          </div>
          <Select5 selectItems={this.renderDropdownItems()}
                   selectItemClick={this.handleAddItemClick}
                   selectedItem={null}
                   useGraySelect={true}
            // placeholder={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox.currency"})}
                   placeholder={"Add New Item"}
                   className={"select--gray"}
                   useAddButton={true}
                   maxItems={6}/>
        </div>
        <button className="discounts-header__buttons-section" onClick={() => this.handleAddSectionClick()}>
          Click here to add section
        </button>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {workSheetsActiveIndex, discountSections} = store.discountsState;
  return {
    // enableWorksheet: store.discountsState.enableWorksheet,
    // enableWorksheetForClients: store.discountsState.enableWorksheetForClients,
    workSheetsActiveIndex,
    discountSections,
    currentSheetSections: getCurrentWorkSheetSections(discountSections, workSheetsActiveIndex),
  };
};

const mapDispatchToProps = {
  // toggleEnableWorksheet,
  // toggleEnableWorksheetForClients,
  setDiscountSections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsHeader);
